export default __webpack_public_path__ + "static/media/KusoldResume.b2c11960.pdf";